import { render, staticRenderFns } from "./SubscriptionsList.vue?vue&type=template&id=8aba8dcc&scoped=true&"
import script from "./SubscriptionsList.vue?vue&type=script&lang=js&"
export * from "./SubscriptionsList.vue?vue&type=script&lang=js&"
import style0 from "./SubscriptionsList.vue?vue&type=style&index=0&id=8aba8dcc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8aba8dcc",
  null
  
)

export default component.exports